import { REDUCER_INDEX } from '../constants'
import { reducer } from '../redux'

export const registerReducer = (state) => ({
  ...state,
  [REDUCER_INDEX]: reducer,
})

export const getState = (state) => state[REDUCER_INDEX]
export const getStateCurrent = (state) => state[REDUCER_INDEX].current

export default reducer
